
import format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'
import { mapGetters } from 'vuex'
import DownloadAsset from '~/mixins/DownloadAsset'

export default {
  mixins: [DownloadAsset],

  props: {
    link: {
      type: Object,
      required: true,
    },

    bgWhite: {
      type: Boolean,
      default: false,
    },

    isAccordion: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isHover: false,

      isAuthorized: false,
    }
  },

  fetch() {
    this.isAuthorized = this.hasGroups(this.link.authorized_user_groups)
  },

  computed: {
    ...mapGetters('user', ['hasGroups']),
    date() {
      if (this.link.published_at) {
        return format(parseISO(this.link.published_at), 'dd.MM.yyyy')
      }

      return ''
    },

    linkType() {
      if (this.link.is_video) {
        return this.$t('video')
      }
      if (this.link.is_image) {
        return this.$t('image')
      }
      if (this.link.extension) {
        return this.link.extension
      }

      return ''
    },

    farIconName() {
      if (this.link.is_video) {
        return 'play-circle'
      }
      if (this.link.is_image) {
        return 'file-image'
      }
      if (['pdf'].includes(this.link.extension)) {
        return 'file-pdf'
      }
      if (['ppt'].includes(this.link.extension)) {
        return 'file-powerpoint'
      }
      if (['docx', 'doc'].includes(this.link.extension)) {
        return 'file-word'
      }
      if (['zip'].includes(this.link.extension)) {
        return 'file-archive'
      }

      return 'link'
    },

    requiresAuthorization() {
      return (
        Array.isArray(this.link.authorized_user_groups) &&
        this.link.authorized_user_groups.length
      )
    },

    requiresTeacherGroup() {
      return (
        this.requiresAuthorization &&
        this.link.authorized_user_groups.includes('teacher')
      )
    },
  },

  methods: {
    startAssetDownload(link) {
      if (this.isAuthorized) {
        this.downloadAsset(link)
      }
    },
  },
}
